module.exports = __webpack_public_path__ + "static/media/logo.2773f11a.png";